
import React from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
// import About from "../pages/about/page";
import LogoPreview from "../pages/logo-preview/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  // {
  //   path: "/about",
  //   element: <About />,
  // },
  {
    path: "/logo-preview",
    element: <LogoPreview />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
